module.exports = __webpack_public_path__ + "static/t-nav-1-f96704d10736d4f0b0a633bc060234b7.png";